import script from "./GreenifiedSaleForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./GreenifiedSaleForm.vue?vue&type=script&setup=true&lang=ts"

import "./GreenifiedSaleForm.vue?vue&type=style&index=0&id=e58f5a24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e58f5a24"]])

export default __exports__